import type { ScenarioMeta } from "@mirage/service-conversation/router_state_types";
import { isFSSEntityWithFileId } from "@mirage/service-conversation/utils/convertFssEntityToChatSource";
import { DocumentInfo } from "@mirage/service-dbx-api/service/grpc/context_engine_apiv2/gen/models_pb";
import type {
  ConversationSource,
  FSSFile,
  FSSFolder,
} from "@mirage/service-fss-bridge/service/bridge_types";

export const getFileExtension = (fileName: string | undefined): string => {
  const fileNameParts = fileName?.match(/^.+\.([^.]+)$/);
  return `.${fileNameParts?.[1]}`;
};

export const parseScenarioMeta = (
  conversationSource: ConversationSource | undefined,
  files: FSSFile[],
  folders: FSSFolder[],
): ScenarioMeta => {
  switch (conversationSource) {
    case "fss-file":
      return { type: "fss_file", files: files };
    case "fss-folder":
      return { type: "fss_folder", folder: folders[0] };
    default:
      return { type: "other" };
  }
};

export const parseEntityId = (entities: (FSSFile | FSSFolder)[]): string[] => {
  return entities.filter(isFSSEntityWithFileId).map((entity) => entity.fileId);
};

export const parseFolderPath = (folders: FSSFolder[]): string => {
  return (
    folders.filter(isFSSEntityWithFileId).map((folder) => folder.path)?.[0] ||
    ""
  );
};

export const parseDocumentInfos = (
  entities: (FSSFile | FSSFolder)[],
): DocumentInfo[] => {
  return entities.filter(isFSSEntityWithFileId).map(
    (entity) =>
      new DocumentInfo({
        uuid: entity.fileId,
        fssRetrieverInfo: {
          fssFileIdentifier: {
            fileId: entity.fileId,
          },
        },
      }),
  );
};
